import React from "react";

const LocationContext = React.createContext();

export function LocationProvider({ children }) {
  const state = React.useState();

  return (
    <LocationContext.Provider value={state}>
      {children}
    </LocationContext.Provider>
  );
}

/**
 * @typedef Location
 * @property {string} id
 * @property {string} name
 * @property {string} company_id
 *
 * @returns {Location}
 */
export function useCurrentLocation() {
  return React.useContext(LocationContext)[0];
}

export function useCurrentLocationSetter() {
  return React.useContext(LocationContext)[1];
}
